export const setWeatherLayer = weatherLayerType => ({
  type: 'SET_WEATHER_LAYER',
  payload: weatherLayerType,
});
